import Box from '@stitch-fix/mode-react/Box';
import { CurrentLook } from '../graphql/types';
import GalleryItemFooter from './GalleryItemFooter';
import LookImage from '../LookImage';
const GalleryItem = ({
  look,
  isShareUrlEnabled = false,
  recipientCreditAmount
}: {
  look: CurrentLook;
  isShareUrlEnabled?: boolean;
  recipientCreditAmount?: string;
}) => {
  return <Box py={1.5} data-testid={`gallery-item-${look.id}`}>
      <LookImage look={look} isShareUrlEnabled={isShareUrlEnabled} recipientCreditAmount={recipientCreditAmount}>
        <GalleryItemFooter look={look} />
      </LookImage>
    </Box>;
};
export default GalleryItem;